<template>
  <div
    v-if="isLoading"
    class="d-flex justify-center align-center"
    :style="{ height: `${containerHeight}px` }"
  >
    <v-progress-circular
      v-bind="{ ...$props, ...$attrs }"
      indeterminate
      color="brandPrimary"
      :size="size"
      :width="width"
    />
  </div>
</template>

<script setup>
// use when page is loading initial data
defineProps({
  isLoading: { type: Boolean, default: true },
  containerHeight: { type: Number, default: 300 },
  size: { type: Number, default: 100 },
  width: { type: Number, default: 10 },
});
</script>
